import imgix from "@config/imgix"
import { useRouter } from "next/router"
import { useMemo } from "react"

export function useCombinedImageUrlsFromSearchParams() {
  const { query } = useRouter()
  const { stone, base, frame, substyle, type } = query

  const urls = useMemo(() => {
    let urls = [getUrl(base as string, substyle as string)]
    if (frame) {
      urls.push(getUrl(frame as string, substyle as string))
    }
    urls.push(getUrl(stone as string, substyle as string))
    return urls
  }, [stone, base, frame, substyle])

  return { urls, type }
}

function getUrl(id: string, substyle: string) {
  return imgix({
    key: `${substyle}/${id}_1`,
    args: {
      w: 600,
      h: 600,
    },
    type: "article",
  })
}
